import { helperFunctions } from 'utils/helperFunctions';
import {
  createKpiTileItem,
  formatPercentageValue,
} from '../../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { formatTimeWithSeconds } = helperFunctions();
    const { avgTimeInPlatform, avgTimeInPlatformDelta } =
      data.getUserAdoptionScorecard;
    return createKpiTileItem(
      'Average Time In Platform',
      formatTimeWithSeconds(avgTimeInPlatform),
      avgTimeInPlatformDelta
        ? {
            isPositiveValue: avgTimeInPlatformDelta >= 0,
            text: formatPercentageValue(Math.abs(avgTimeInPlatformDelta)),
            sideLabel: '',
            showArrow: Number(avgTimeInPlatformDelta) !== 0,
          }
        : null
    );
  },
};
